export type BuildParamsType = { nameParam: string; value?: string }

// Generic method
export const buildParams = (params: BuildParamsType[]) => {
  let queryParams = ''
  for (let i = 0; i < params.length; i++) {
    if (!!params[i].value) {
      queryParams += `${params[i].nameParam}=${params[i].value}&`
    }
  }
  //On retire le dernier caractère qui est un "&"
  return queryParams.slice(0, queryParams.length - 1)
}

// For apis.admin.business
export const buildParamsAdminBusiness = (
  filters: BusinessesFilters,
  type: 'search' | 'export',
  businessesNumber: number,
  currentPage: number
) => {
  const { company, noCompanyBusinesses, region, responsable, sources, statuses } = filters
  let queryParams = type === 'export' ? `size=${businessesNumber}&` : `page=${currentPage - 1}&`

  if (!!company) {
    queryParams += `companyId=${company.value}&`
  }
  if (noCompanyBusinesses) {
    queryParams += 'noCompanies=true&'
  }
  if (!!region) {
    queryParams += `regionId=${region.value}&`
  }
  if (!!responsable) {
    queryParams += `userId=${responsable.value}&`
  }
  //Si tous les checkboxes ont été cochées, on n'entre pas dans le if ci-dessous et on ne filtre pas sur les sources
  if (sources.find((source) => !source.value)) {
    let sourcesParams = 'type='
    sources.map((source) => {
      if (source.value) {
        sourcesParams += `${source.type},`
      }
    })
    //On vérifie qu'au moins une source a été sélectionnée
    if (sourcesParams !== 'type=') {
      //Après ajout des sources, on retire la dernière virgule et on ajoute le '&'
      queryParams += `${sourcesParams.slice(0, sourcesParams.length - 1)}&`
    }
  }
  //Idem pour les statuts
  if (statuses.find((status) => !status.value)) {
    let statusesParams = 'state='
    statuses.map((status) => {
      if (status.value) {
        statusesParams += `${status.type},`
      }
    })
    if (statusesParams !== 'state=') {
      queryParams += `${statusesParams.slice(0, statusesParams.length - 1)}&`
    }
  }
  //On retire le dernier caractère qui est un "&"
  return queryParams.slice(0, queryParams.length - 1)
}
